import { render } from "./FairUsePolicy.vue?vue&type=template&id=74ad9f09&scoped=true"
import script from "./FairUsePolicy.vue?vue&type=script&lang=js"
export * from "./FairUsePolicy.vue?vue&type=script&lang=js"

import "./FairUsePolicy.vue?vue&type=style&index=0&id=74ad9f09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ad9f09"]])

export default __exports__